import { CurationClassification, CurationStatus, ImageClassification } from './types';

export const STATUS_COLOR: Record<CurationStatus, 'default' | 'info' | 'success' | 'error'> = {
  pending: 'default',
  processing: 'default',
  scored: 'info',
  failed: 'error',
};

export const CLASSIFICATION_STYLE: Record<CurationClassification, { bgcolor: string; color: string }> = {
  set_live: { bgcolor: '#b8960c', color: '#fff' },
  needs_review: { bgcolor: '#71797E', color: '#fff' },
  not_suitable: { bgcolor: '#a0522d', color: '#fff' },
};

export const CLASSIFICATION_LABEL: Record<CurationClassification, string> = {
  set_live: 'Luxury',
  needs_review: 'Midrange',
  not_suitable: 'Budget',
};

export const CLASSIFICATION_FALLBACK_LABEL = 'Other';
export const CLASSIFICATION_FALLBACK_STYLE = { bgcolor: '#d32f2f', color: '#fff' } as const;

export const IMAGE_CLASSIFICATION_COLOR: Record<ImageClassification, 'success' | 'warning' | 'error' | 'default'> = {
  luxury: 'success',
  acceptable: 'warning',
  not_luxury: 'error',
  not_scored: 'default',
};

export const IMAGE_CLASSIFICATION_LABEL: Record<ImageClassification, string> = {
  luxury: 'Luxury',
  acceptable: 'Acceptable',
  not_luxury: 'Not Luxury',
  not_scored: 'Not Scored',
};

export const REVIEW_DECISION_COLOR: Record<string, 'success' | 'error' | 'default'> = {
  approved: 'success',
  rejected: 'error',
};

export const REVIEW_DECISION_LABEL: Record<string, string> = {
  approved: 'Approved',
  rejected: 'Rejected',
};

export const STATUS_OPTIONS: Array<{ value: CurationStatus | ''; label: string }> = [
  { value: '', label: 'All Statuses' },
  { value: 'pending', label: 'Pending' },
  { value: 'processing', label: 'Processing' },
  { value: 'scored', label: 'Scored' },
  { value: 'failed', label: 'Failed' },
];

export const CLASSIFICATION_OPTIONS: Array<{ value: CurationClassification | ''; label: string }> = [
  { value: '', label: 'All Classifications' },
  { value: 'set_live', label: 'Luxury' },
  { value: 'needs_review', label: 'Midrange' },
  { value: 'not_suitable', label: 'Budget' },
];

export const DEFAULT_PAGE_SIZE = 50;

export const HERO_IMAGE_COUNT = 3;

export const SCORE_BAR_PALETTE = {
  gold: '#b8960c',
  silver: '#71797E',
  bronze: '#a0522d',
  budgetRed: '#d32f2f',
  track: 'rgba(0, 0, 0, 0.12)',
} as const;

export function getScoreBarColor(score: number | null) {
  if (score == null) {
    return SCORE_BAR_PALETTE.track;
  }

  if (score >= 70) {
    return SCORE_BAR_PALETTE.gold;
  }

  if (score >= 55) {
    return SCORE_BAR_PALETTE.silver;
  }

  if (score >= 40) {
    return SCORE_BAR_PALETTE.bronze;
  }

  return SCORE_BAR_PALETTE.budgetRed;
}

export function getClassificationTextColor(classification?: CurationClassification | null) {
  if (classification === 'set_live') {
    return SCORE_BAR_PALETTE.gold;
  }

  if (classification === 'needs_review') {
    return SCORE_BAR_PALETTE.silver;
  }

  if (classification === 'not_suitable') {
    return SCORE_BAR_PALETTE.bronze;
  }

  return SCORE_BAR_PALETTE.budgetRed;
}

export function buildImageUrl(imageServiceId: string, width = 400) {
  const host = window.configs.IMAGE_HOST;
  return `${host}/q_auto:eco,c_fill,g_auto,w_${width}/${imageServiceId}`;
}
